<div class="notification-conditions">
  <label class="title">Conditions</label>

  <div class="d-flex align-items-center justify-content-between">
    <!-- Start: Logical operator -->
    <div class="logical-operator">
      <app-input-select
        [items]="logicalOperationOptions"
        [parentForm]="form"
        controlName="logicalOperator"
      ></app-input-select>
    </div>
    <!-- End: Logical operator -->

    <app-button text="Add Condition"
                variant="info"
                size="sm"
                type="button"
                (clicked)="onAddCondition()"
    />
  </div>

  <!-- Start: Conditions list -->
  @if (form.get('expressions').value && form.get('expressions').value.length > 0) {
    <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 20px;">
      <div *ngFor="let expression of form.get('expressions').value; let i = index">
        <app-trial-notification-condition
          [index]="i"
          [elements]="diaryForm.elements || []"
          [expression]="expression"
          [elementOptions]="elementOptions"
          [logicalOperator]="form.get('logicalOperator').value"
          (remove)="onRemoveCondition(i)"
          (changed)="onHandleConditionChanged($event, i)"
        ></app-trial-notification-condition>
      </div>
    </div>
  }
  <!-- End: Conditions list -->

</div>
